/**
 * Enum specifying font weights, typically applied to text elements.
 */
export var FontWeight;
(function (FontWeight) {
    FontWeight["None"] = "";
    FontWeight["Bold"] = "bold";
    FontWeight["Light"] = "light";
    FontWeight["Normal"] = "normal";
})(FontWeight || (FontWeight = {}));
//# sourceMappingURL=FontWeight.js.map